import { render } from "./verify_otp.vue?vue&type=template&id=822e2fe6&scoped=true"
import script from "./verify_otp.vue?vue&type=script&lang=js"
export * from "./verify_otp.vue?vue&type=script&lang=js"

import "./verify_otp.vue?vue&type=style&index=0&id=822e2fe6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822e2fe6"]])

export default __exports__